import { useTranslation } from "react-i18next"
import { FilteredProducts } from "../../components/FilteredProducts"
import { HiddenHeader } from "../../components/HiddenHeader"
import type { DeadlineStatus } from "../../graphql"
import { FilterHeader, FilterHeaderConnected } from "./FilterHeader"
import s from "./FilterView.module.scss"

export const FilterViewConnected = ({
  isIncomplete,
  deadlineStatus,
  isMandatory,
}: {
  isIncomplete: boolean | undefined
  isMandatory: boolean | undefined
  deadlineStatus: DeadlineStatus | undefined
}) => {
  const { t } = useTranslation()

  const getProductFilter = () => {
    if (isIncomplete && isMandatory) {
      return "mandatory_and_incomplete"
    } else if (isIncomplete) {
      return "incomplete"
    } else if (isMandatory) {
      return "mandatory"
    }
  }

  let title: string | null = null
  let description: string | null = null

  if (isIncomplete && isMandatory) {
    title = "user.MANDATORY_AND_INCOMPLETE"
    description = "user.MANDATORY_AND_INCOMPLETE_PRODUCTS"
  } else if (isIncomplete) {
    title = "user.INCOMPLETE"
    description = "user.INCOMPLETE_PRODUCTS"
  } else if (isMandatory) {
    title = "user.MANDATORY"
    description = "user.MANDATORY_PRODUCTS"
  }

  if (!title || !description) return null

  return (
    <>
      <FilterHeaderConnected
        deadlineStatus={deadlineStatus}
        title={t(title)}
        description={t(description)}
      />
      <HiddenHeader title={t("product.PRODUCTS")} tag="h2" />
      <FilteredProducts
        input={{
          variant: getProductFilter(),
          deadlineStatus,
        }}
      />
    </>
  )
}

type FilterViewProps = {
  title: string
  description: string
  dueCount: number
  overdueCount: number
  deadlineStatus: "due" | "overdue" | undefined
  productFilter:
    | "mandatory"
    | "incomplete"
    | "mandatory_and_incomplete"
    | undefined
}

export const FilterView = ({
  title,
  description,
  deadlineStatus,
  dueCount,
  overdueCount,
  productFilter,
}: FilterViewProps) => {
  return (
    <div className={s.view}>
      <FilterHeader
        title={title}
        description={description}
        deadlineStatus={deadlineStatus}
        dueCount={dueCount}
        overdueCount={overdueCount}
      />
      <HiddenHeader title="Products" tag="h2" />
      <FilteredProducts
        input={{
          variant: productFilter,
          deadlineStatus: deadlineStatus,
        }}
      />
    </div>
  )
}
